export default class AuthModel {
  constructor(formErrors) {
    this.formErrors = formErrors;
    this.formData = {
      login: null,
      password: null
    };

    this.apiAttributes = {
      login: "login",
      password: "password"
    };
  }

  getApiData() {
    return {
      login: this.formData.login,
      password: this.formData.password
    };
  }
}
